import RightModal from "./RightModal";
import AuthBlock from "../../customer/AuthBlock";

export default function AuthPopup(){

    return (<RightModal >
        <AuthBlock />
    </RightModal>)
}